import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';
import { IUpdateCourtExpectedPaymentRequest } from '../interface/court/CourtExpectedPayment/IUpdateCourtExpectedPaymentRequest';
import { ICourtExpectedPayment } from '../interface/court/CourtExpectedPayment/ICourtExpectedPayment';

enum CourtExpectedPaymentEnum {
	getByCourt = '/by-type?idCourt=',
	update = '/',
}

export default class CourtExpectedPaymentService extends ApiService {
	constructor(restClient: AxiosInstance) {
		super(restClient, '/court/expected-payment');
	}

	public getByCourt = async (idCourt: string): Promise<ICourtExpectedPayment[]> => await this.GET(CourtExpectedPaymentEnum.getByCourt + idCourt);
	public update = async (request: IUpdateCourtExpectedPaymentRequest) => await this.POST(CourtExpectedPaymentEnum.update, request);
}
